import { useIntl } from 'react-intl';

import { useDoohReportFormatters } from '@/components/doohReport/common/hooks/useDoohReportFormatters';

type Props = {
  onTargetPct: number | null;
  baselineOnTargetPct: number | null;
  onTargetVsBaselinePts: number | null;
  /** On-target impressions the campaign's on-target share drove. */
  targetImpacts: number | null;
};

/**
 * Hover content of the "above avg." tag: how the campaign's on-target share breaks
 * down into the benchmark plus the uplift Sonata added on top of it.
 */
export default function AboveBenchmarkTooltip({
  onTargetPct,
  baselineOnTargetPct,
  onTargetVsBaselinePts,
  targetImpacts
}: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const { formatAbbreviated, formatPercent } = useDoohReportFormatters();

  return (
    <div className="metricDetailCards__aboveBenchmarkTooltip">
      <span>
        {formatMessage(
          {
            defaultMessage:
              'This percentage is the aggregated average of on-target presence across all screens, which drove the {impressions} on-target impressions.',
            id: 'doohReport.metricDetailCards.aboveBenchmarkTooltip.intro'
          },
          { impressions: formatAbbreviated(targetImpacts) }
        )}
      </span>
      <ul className="metricDetailCards__aboveBenchmarkBreakdown">
        <li>
          {formatMessage(
            {
              defaultMessage: '{pct} (DOOH campaign average)',
              id: 'doohReport.metricDetailCards.aboveBenchmarkTooltip.benchmark'
            },
            { pct: formatPercent(baselineOnTargetPct) }
          )}
        </li>
        <li>
          {formatMessage(
            { defaultMessage: '{uplift} (Uplift)', id: 'doohReport.metricDetailCards.aboveBenchmarkTooltip.uplift' },
            { uplift: <strong>+ {formatPercent(onTargetVsBaselinePts, 2)}</strong> }
          )}
        </li>
        <li>
          {formatMessage(
            {
              defaultMessage: "= {pct} (Your campaign's average on-target performance)",
              id: 'doohReport.metricDetailCards.aboveBenchmarkTooltip.campaign'
            },
            { pct: formatPercent(onTargetPct, 2) }
          )}
        </li>
      </ul>
    </div>
  );
}
